export default __webpack_public_path__ + "static/media/features-1 (2).ace26a6d.jpg";